
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10 5c2.92 0 5.482.981 6 1.188C16.518 5.982 19.08 5 22 5c3.227 0 6.375 1.313 6.375 1.313l.625.281V27H17.719c-.346.597-.979 1-1.719 1s-1.373-.403-1.719-1H3V6.594l.625-.281S6.773 5 10 5zm0 2c-2.199 0-4.232.69-5 .969v16.125c1.188-.392 2.897-.875 5-.875 2.057 0 3.888.506 5 .875V7.969C14 7.626 11.933 7 10 7zm12 0c-1.933 0-4 .626-5 .969v16.125c1.112-.369 2.943-.875 5-.875 2.103 0 3.813.483 5 .875V7.969C26.232 7.69 24.199 7 22 7z"}})])
          )
        }
      }
    